import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Kbd,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  IconButton,
  useColorModeValue
} from '@chakra-ui/react';
import { HelpCircle } from 'lucide-react';

interface KeyboardShortcut {
  key: string;
  description: string;
}

interface KeyboardShortcutsHelpProps {
  isOpen: boolean;
  onClose: () => void;
}

const shortcuts: KeyboardShortcut[] = [
  { key: '→', description: 'Next slide' },
  { key: 'Space', description: 'Next slide' },
  { key: '←', description: 'Previous slide' },
  { key: 'C', description: 'Toggle captions' },
  { key: 'H', description: 'Show this help' }
];

const KeyboardShortcutsHelp: React.FC<KeyboardShortcutsHelpProps> = ({ isOpen, onClose }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
      <ModalContent bg={bgColor} borderColor={borderColor} borderWidth="1px" boxShadow="xl" maxW="400px">
        <ModalHeader pb={2}>Keyboard Shortcuts</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={3} align="stretch">
            {shortcuts.map((shortcut, index) => (
              <HStack key={index} justify="space-between">
                <Text>{shortcut.description}</Text>
                <Kbd>{shortcut.key}</Kbd>
              </HStack>
            ))}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default KeyboardShortcutsHelp;
